import type { JSX } from "react";
import {
  BookOpenText,
  BriefcaseBusiness,
  ClipboardList,
  FileText,
  FolderKanban,
  FlaskConical,
  Route,
  Settings2,
  UsersRound
} from "lucide-react";

import type { NavGroup, NavItem } from "./types";

export const navItems: NavItem[] = [
  { id: "tenders", label: "Tenders", icon: BriefcaseBusiness },
  { id: "cases", label: "Proposals", icon: FolderKanban },
  { id: "playbook", label: "Playbook", icon: BookOpenText },
  { id: "question-prompt", label: "Question Template", icon: ClipboardList },
  { id: "plan-prompt", label: "Outline Template", icon: Route },
  { id: "feasibility-prompt", label: "Feasibility Template", icon: FlaskConical },
  { id: "profile-references", label: "Company Library", icon: UsersRound },
  { id: "cvs", label: "Team Profiles", icon: FileText },
  { id: "settings", label: "Settings", icon: Settings2 }
];

export const navGroups: NavGroup[] = [
  {
    id: "workspace",
    label: "Workspace",
    items: navItems.filter(
      (item) =>
        item.id === "tenders" ||
        item.id === "cases" ||
        item.id === "playbook" ||
        item.id === "profile-references" ||
        item.id === "cvs" ||
        item.id === "settings"
    )
  },
  {
    id: "prompts",
    label: "AI Templates",
    items: navItems.filter(
      (item) =>
        item.id === "question-prompt" || item.id === "plan-prompt" || item.id === "feasibility-prompt"
    )
  }
];

export const getNavLabel = (activeItem: NavItem["id"]): string =>
  navItems.find((item) => item.id === activeItem)?.label ?? "Workspace";

export const ThemeIcon = ({ className }: { className?: string }): JSX.Element => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={className}>
    <path d="M12 3v2.5M12 18.5V21M4.9 4.9l1.7 1.7M17.4 17.4l1.7 1.7M3 12h2.5M18.5 12H21M4.9 19.1l1.7-1.7M17.4 6.6l1.7-1.7" />
    <path d="M12 7.2a4.8 4.8 0 1 0 0 9.6a4.8 4.8 0 0 0 0-9.6Z" />
  </svg>
);
